require('./round-detail.jade')
require('./players-analysis/players-analysis.jade')
require('./round-basic-chart/round-basic-chart.jade')
require('./round-info/round-info.jade')
require('./round-map/round-map.jade')
require('./round-score-chart/round-score-chart.jade')
require('./round-stroke-chart/round-stroke-chart.jade')
require('./score-card-info/score-card-info.jade')
require('./score-card-memo/memo-show.jade')
require('./score-card-memo/memo-edit.jade')

# Load Css
require('../../../sass/web/html/_round_detail.scss')

require('angular')
require('angular-route')
require('../../core/translation/translation-module')
require('../components/flash/flash-module')
require('../components/auth/auth-module')
require('../components/common-wrapper/common-wrapper-module')
require('../components/location-tracking/location-tracking-module')
require('../components/analysis-charts/analysis-charts-module')
require('../components/remote-api/remote-api-module')
require('../components/score-card/score-card-module')
require('../components/payment/payment-module')
require('../components/error-handler/error-handler-module')
require('../components/hdcp/hdcp-module')
require('../components/number/number-module')
require('../components/map/map-module')
require('../components/analyze-access/analyze-access-module')

RoundDetailCtrl = require('./round-detail-controller')
RoundDetailInfoCtrl = require('./round-info/round-info-controller')
RoundDetailService = require('./round-detail-service.coffee')
PlayersAnalysisCtrl = require('./players-analysis/players-analysis-controller')
RoundMapCtrl = require('./round-map/round-map-controller.coffee')
RoundBasicChartCtrl = require('./round-basic-chart/round-basic-chart-controller.coffee')
RoundScoreChartCtrl = require('./round-score-chart/round-score-chart-controller.coffee')
RoundStrokeChartCtrl = require('./round-stroke-chart/round-stroke-chart-controller.coffee')
ScoreCardInfoCtrl = require('./score-card-info/score-card-info-controller.coffee')
MemoCtrl = require('./score-card-memo/memo-controller.coffee')
MemoModalCtrl = require('./score-card-memo/memo-modal-controller.coffee')
MemoService = require('./score-card-memo/memo-service.coffee')

modules = [
  'ngRoute'
  'ui.bootstrap'
  'gnp-translation'
  'gnp-flash'
  'gnp-auth'
  'gnp-common-wrapper'
  'gnp-location-tracking'
  'gnp-analysis-charts'
  'gnp-score-card'
  'gnp-payment'
  'gnp-remote-api'
  'gnp-error-handler'
  'gnp-hdcp'
  'gnp-number'
  'gnp-map'
  'gnp-analyze-access'
]
angular.module 'gnp-app-round-detail', modules
  .config ['$routeProvider', ($routeProvider) ->

    $routeProvider.when '/round-detail/:id',
      templateUrl: 'web/round-detail/round-detail.jade'
      controller: 'RoundDetailCtrl'
      resolve:
        userInfo: ['AuthService', 'AccountService', (AuthService, AccountService) ->
          AccountService.getUserInfo() if AuthService.isSignedIn()
        ]
        roundInfo: ['RoundAPIService', '$route', (RoundAPIService, $route) ->
          params =
            user_id: $route.current.params.user_id
          RoundAPIService.getRound($route.current.params.id, true, params)
        ]
        playersAnalysis: ['RoundDetailService', '$route', (RoundDetailService, $route) ->
          params =
            user_id: $route.current.params.user_id
          RoundDetailService.getAnalysisDataRound($route.current.params.id, params)
        ]
        goalSettings: ['GoalAPIService', '$route', (GoalAPIService, $route) ->
          params =
            user_id: $route.current.params.user_id
          GoalAPIService.getGoalSettings(params)
        ]
        allMembersAnalysis: ['ScoreCardAPIService','$route', (ScoreCardAPIService,$route) ->
          params =
            user_id: $route.current.params.user_id
          ScoreCardAPIService.getAllMembers(params)
        ]
      title: '_ROUND_DETAIL.TITLE'
      permission:
        signInRequired: false
  ]
  .config ['$translateProvider', ($translateProvider) ->
    $translateProvider
      .translations 'en', require('./i18n/en')
      .translations 'ja', require('./i18n/ja')
  ]
  .controller 'RoundDetailCtrl', RoundDetailCtrl
  .controller 'RoundDetailInfoCtrl', RoundDetailInfoCtrl
  .controller 'PlayersAnalysisCtrl', PlayersAnalysisCtrl
  .controller 'RoundMapCtrl', RoundMapCtrl
  .controller 'RoundBasicChartCtrl', RoundBasicChartCtrl
  .controller 'RoundScoreChartCtrl', RoundScoreChartCtrl
  .controller 'RoundStrokeChartCtrl', RoundStrokeChartCtrl
  .controller 'ScoreCardInfoCtrl', ScoreCardInfoCtrl
  .controller 'MemoCtrl', MemoCtrl
  .controller 'MemoModalCtrl', MemoModalCtrl
  .factory 'RoundDetailService', RoundDetailService
  .factory 'MemoService', MemoService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/round-detail/round-detail-module.coffee